module.exports = __webpack_public_path__ + "img/screenshotMusicApp.ebc0f68d.jpg";